import React, { useEffect, useState, useRef } from "react"
import { useDispatch } from "react-redux"

import {
  Table,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap"
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation"
import { Link } from "react-router-dom"
import {
  insertProformaData,
  deleteProformaData,
  getPaymentFlowsAction,
} from "../../store/planlama-ve-takvim/actions"
import { set } from "lodash"

import * as XLSX from "xlsx"
import { saveAs } from "file-saver"
import { wait } from "@testing-library/react"

function filepathChanger(fullPath) {
  // return fullPath
  var returnPath =
    process.env["REACT_APP_BACKEND_URL"] + "app/media/" + fullPath
  return returnPath
}
function getFileName(fullPath) {
  if (fullPath) {
    var startIndex =
      fullPath.indexOf("\\") >= 0
        ? fullPath.lastIndexOf("\\")
        : fullPath.lastIndexOf("/")
    var filename = fullPath.substring(startIndex)
    if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
      filename = filename.substring(1)
    }
    return filename
  }
}
const CollapsibleTable = props => {
  const handleReClick = paymentId => {
    const button = document.getElementById(`button_oa-${paymentId}`)
    if (button) {
      button.click()
    }
  }

  const [NewProformaData, setNewProformaData] = useState(props.proformas)

  const [saved_proforma_data, setSavedProformaData] = useState({})
  const handleExport = async (event, rowId, proforma_name) => {
    let table = document.getElementById(rowId) // Select table by ID
    if( table === null) {
      // Wait for toggleRow to finish and table to be rendered
      await new Promise(resolve => {
        toggleRow(rowId)
        setTimeout(resolve, 100) // Wait 100ms for DOM update
      })
      table = document.getElementById(rowId)
    }

    if (!table) return

    const rows = Array.from(table.querySelectorAll("tr")).map(row =>
      Array.from(row.querySelectorAll("th, td")).map(cell =>
        cell.innerText.trim()
      )
    )

    // Convert array to a worksheet
    const ws = XLSX.utils.aoa_to_sheet(rows)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, "Table Data")

    // Write and trigger download
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" })
    const dataBlob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    })

    saveAs(dataBlob, proforma_name + ".xlsx")
  }
  const getUserName = user_id => {
    let user = props.users.find(user => user.id == user_id)
    if (user) {
      return user.name
    }
    return ""
  }
  const [themeDataKeys, setThemeDataKeys] = useState([])
  const appendForValue = label => {
    setThemeDataKeys(prev => {
      if (!prev.includes(label)) {
        return [...prev, label]
      }
      return prev
    })
  }
  const filterDate = date => {
    const processDate = new Date(date)

    const startDate = new Date(props.startDate)
    startDate.setHours(0, 0, 0, 0)
    const endDate = new Date(props.endDate)
    endDate.setHours(0, 0, 0, 0)
    if (processDate >= startDate && processDate <= endDate) {
      return true
    }
    return false
  }

  const dispatch = useDispatch()
  const [expandedRows, setExpandedRows] = useState([])
  const [new_theme_data_modal_status, set_new_theme_data_modal_status] =
    useState(false)
  const [process_proforma, set_process_proforma] = useState({})

  const appendThemeData = (event, proforma) => {
    event.preventDefault()
    set_new_theme_data_modal_status(true)
    set_process_proforma(proforma)
  }
  const new_theme_data_modal_action = () => {
    set_new_theme_data_modal_status(!new_theme_data_modal_status)
  }

  const [proformaData, setProformaData] = useState([])

  const users = props.users
  const user_type = props.user_type
  const AuthUserData = props.AuthUserData

  const toggleRow = id => {
    setExpandedRows(prev =>
      prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]
    )
  }
  const proformaSaved = newProforma => {
    if (newProforma.proforma_id) {
      NewProformaData.map(proforma => {
        console.log(proforma.id)
        console.log(newProforma.proforma_id)
        if (proforma.id == newProforma.proforma_id) {
          proforma.theme_data.push(newProforma)
        }
      })
    }
  }
  const handle_proforma_data_form = (event, values) => {
    console.log(user_type)
    if (
      user_type === "SPS" ||
      user_type === "CRA" ||
      user_type === "DCT" ||
      user_type === "SC" ||
      user_type === "SPS"
    ) {
      values.user_id = AuthUserData.id
    }

    let files = document.querySelectorAll('[name^="files["]')
    let filePromises = Array.from(files).map(file => {
      return new Promise((resolve, reject) => {
        var file_id = file.id.slice(3)
        if (file.files.length > 0) {
          let full_file_name = getFileName(file.value)
          let fileObj = file.files[0]
          let reader = new FileReader()

          // Read image files as DataURL
          console.log(fileObj.type)
          const isText =
            fileObj.type.startsWith("text/") ||
            full_file_name.endsWith(".txt") ||
            full_file_name.endsWith(".csv")

          if (isText) {
            reader.readAsText(fileObj) // sadece düz metin dosyaları için
          } else {
            reader.readAsDataURL(fileObj) // .doc, .docx, .pdf gibi binary dosyalar için
          }

          reader.onload = function () {
            if (!values["files"]) {
              values["files"] = {}
            }
            values["files"][file_id] = {
              content: reader.result, // Base64 encoded for images
              type: fileObj.type,
              file_full_name: full_file_name,
            }
            resolve()
          }

          reader.onerror = function (error) {
            console.error("File reading error:", error)
            reject(error)
          }
        } else {
          resolve()
        }
      })
    })

    Promise.all(filePromises)
      .then(() => {
        console.log(values)
        dispatch(insertProformaData(values))
      })
      .catch(error => {
        console.error("File processing error:", error)
      })
  }

  useEffect(() => {
    if (props.saved_proforma_theme) {
      if (props.saved_proforma_theme.saved_data) {
        handleReClick(props.payment_id)
        // get_payment_flows.bind(this, payment.id, props.current_proje.id)
        set_new_theme_data_modal_status(false)
      }
    }
  }, [props.saved_proforma_theme])
  useEffect(() => {
    if (props.proformas.theme_data) {
      console.log("props.proformas.theme_data")
      console.log(props.proformas.theme_data)
    }
  }, [props.proformas.theme_data])
  useEffect(() => {
    setNewProformaData(props.proformas)
  }, [props.proformas])
  const areyousuredelete = id => {
    if (window.confirm("Silmek istediğinize emin misiniz?")) {
      dispatch(deleteProformaData(id))
      dispatch({ type: "RESET_PROFORMA_THEME" })
      dispatch(getPaymentFlowsAction(props.payment_id, props.project_id))
    }
  }

  const availabelPlusArray = ["ADM", "PM", "SC", "CRA", "DCT"]
  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          {(NewProformaData && NewProformaData.length > 0 && (
            <Table className="table align-middle table-nowrap table-hover mb-0 ">
              <thead>
                <tr>
                  <th scope="col">Detay</th>
                  <th scope="col">Proforma</th>
                  <th scope="col">Durum</th>
                  <th scope="col">İşlemler</th>
                </tr>
              </thead>
              <tbody>
                {NewProformaData.map(row => (
                  <React.Fragment key={row.id}>
                    <tr>
                      <td>
                        <button
                          type="submit"
                          className="btn btn-success save-workflow"
                          onClick={() => toggleRow(row.id)}
                        >
                          {expandedRows.includes(row.id) ? "Gizle" : "Detay"}
                        </button>
                      </td>
                      <td>{row.title}</td>
                      <td>
                        {row.status.toString() == "true" ? "Aktif" : "Pasif"}
                      </td>
                      <td>
                        <div className="d-flex gap-3">
                          {(row.objects && row.objects.length > 0 && (
                            <div>
                              {(row.status &&
                                row.status.toString() == "true" &&
                                availabelPlusArray.includes(
                                  props.user_type
                                ) && (
                                  <Button
                                    color="success"
                                    onClick={e => {
                                      appendThemeData(e, row)
                                    }}
                                  >
                                    +
                                  </Button>
                                )) || <></>}
                              {props.user_type == "ADM" && (
                                <Button
                                  color="success"
                                  onClick={e => {
                                    handleExport(e, row.id, row.title)
                                  }}
                                >
                                  Excel Indir
                                </Button>
                              )}
                              {props.user_type == "PM" && (
                                <Button
                                  color="success"
                                  onClick={e => {
                                    handleExport(e, row.id, row.title)
                                  }}
                                >
                                  Excel Indir
                                </Button>
                              )}
                            </div>
                          )) || <></>}
                        </div>
                      </td>
                    </tr>
                    {expandedRows.includes(row.id) && (
                      <tr>
                        <td colSpan={4}>
                          <Table
                            className="table align-middle table-nowrap table-hover mb-0 "
                            width="100%"
                            id={row.id}
                          >
                            <thead>
                              <tr>
                                <th>Kullanıcı</th>
                                <th>Değer</th>
                                {row.objects &&
                                  row.objects.length > 0 &&
                                  row.objects.map((subRow, sindex) => (
                                    <React.Fragment key={subRow.id}>
                                      <th>{subRow.input_label}</th>
                                    </React.Fragment>
                                  ))}

                                <th>Tarih</th>
                                <th>İşlem</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(row.theme_data &&
                                row.theme_data.length > 0 &&
                                row.theme_data
                                  .filter(themeData =>
                                    filterDate(themeData.create_datetime)
                                  )
                                  .map((subRow, sindex) => (
                                    <tr>
                                      {getUserName(subRow.user_id) != "" && (
                                        <React.Fragment key={subRow.id}>
                                          <td>{getUserName(subRow.user_id)}</td>
                                          <td>{subRow.price}</td>
                                          {(row.objects &&
                                            row.objects.length > 0 &&
                                            row.objects.map(prfrm => (
                                              <React.Fragment key={prfrm.id}>
                                                <td>
                                                  {prfrm.input_detail ==
                                                    "Text" && (
                                                    <React.Fragment>
                                                      {
                                                        subRow.payload[
                                                          prfrm.input_label
                                                        ]
                                                      }
                                                    </React.Fragment>
                                                  )}
                                                  {prfrm.input_detail ==
                                                    "Select" && (
                                                    <React.Fragment>
                                                      {(prfrm.addAdditionalRow &&
                                                        prfrm.addAdditionalRow
                                                          .length > 0 &&
                                                        prfrm.addAdditionalRow.map(
                                                          additionalElement => (
                                                            <React.Fragment
                                                              key={
                                                                additionalElement.id
                                                              }
                                                            >
                                                              {subRow.payload[
                                                                prfrm
                                                                  .input_label
                                                              ] ==
                                                                additionalElement.deger && (
                                                                <React.Fragment>
                                                                  {
                                                                    additionalElement.title
                                                                  }
                                                                </React.Fragment>
                                                              )}
                                                            </React.Fragment>
                                                          )
                                                        )) || <></>}
                                                    </React.Fragment>
                                                  )}

                                                  {prfrm.input_detail ==
                                                    "Radio" && (
                                                    <React.Fragment>
                                                      {(prfrm.addAdditionalRow &&
                                                        prfrm.addAdditionalRow
                                                          .length > 0 &&
                                                        prfrm.addAdditionalRow.map(
                                                          additionalElement => (
                                                            <React.Fragment
                                                              key={
                                                                additionalElement.id
                                                              }
                                                            >
                                                              {subRow.payload[
                                                                prfrm
                                                                  .input_label
                                                              ] ==
                                                                additionalElement.deger && (
                                                                <React.Fragment>
                                                                  {
                                                                    additionalElement.title
                                                                  }
                                                                </React.Fragment>
                                                              )}
                                                            </React.Fragment>
                                                          )
                                                        )) || <></>}
                                                    </React.Fragment>
                                                  )}
                                                  {prfrm.input_detail ==
                                                    "Checkbox" && (
                                                    <React.Fragment>
                                                      {(prfrm.addAdditionalRow &&
                                                        prfrm.addAdditionalRow
                                                          .length > 0 &&
                                                        prfrm.addAdditionalRow.map(
                                                          additionalElement => (
                                                            <React.Fragment
                                                              key={
                                                                additionalElement.id
                                                              }
                                                            >
                                                              {subRow.payload[
                                                                prfrm
                                                                  .input_label
                                                              ] && Array.isArray(subRow.payload[prfrm.input_label]) &&
                                                              subRow.payload[prfrm.input_label].includes(
                                                                additionalElement.deger
                                                              ) && (
                                                                <React.Fragment>
                                                                  <span class="bg-success badge me-2">
                                                                    {
                                                                      additionalElement.title
                                                                    }
                                                                    ,{" "}
                                                                  </span>
                                                                </React.Fragment>
                                                              )}
                                                            </React.Fragment>
                                                          )
                                                        )) || <></>}
                                                    </React.Fragment>
                                                  )}
                                                  {prfrm.input_detail ==
                                                    "File" && (
                                                    <React.Fragment>
                                                      {(subRow.payload[
                                                        prfrm.input_label
                                                      ]["file_path"] &&
                                                        subRow.payload[
                                                          prfrm.input_label
                                                        ]["file_path"] !=
                                                          "" && (
                                                          <a
                                                            target="_payment_flow_file"
                                                            href={filepathChanger(
                                                              subRow.payload[
                                                                prfrm
                                                                  .input_label
                                                              ]["file_path"]
                                                            )}
                                                            className="text-dark fw-medium"
                                                          >
                                                            <i className="mdi mdi-file-document font-size-16 align-middle text-primary me-2"></i>
                                                            {
                                                              subRow.payload[
                                                                prfrm
                                                                  .input_label
                                                              ][
                                                                "file_full_name"
                                                              ]
                                                            }
                                                          </a>
                                                        )) || <></>}
                                                    </React.Fragment>
                                                  )}
                                                </td>
                                              </React.Fragment>
                                            ))) || <td>Veri Yok</td>}
                                          <td>{subRow.create_datetime}</td>
                                          <td>
                                            <div>
                                              {((user_type === "ADM" ||
                                                user_type === "PM" ||
                                                user_type === "DCT" ||
                                                user_type === "SC" ||
                                                user_type === "CRA") && (
                                                <Link
                                                  to="#"
                                                  className="text-danger"
                                                  onClick={() =>
                                                    areyousuredelete(subRow.id)
                                                  }
                                                >
                                                  <i className="mdi mdi-delete font-size-18"></i>
                                                </Link>
                                              )) || <></>}
                                            </div>
                                          </td>
                                        </React.Fragment>
                                      )}
                                    </tr>
                                  ))) || (
                                <tr>
                                  <td
                                    colSpan={row.objects.length + 3}
                                    align="center"
                                  >
                                    <b>Veri Yok</b>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          )) || (
            <div className="text-center">
              <h4>Veri Yok</h4>
            </div>
          )}
        </Col>
      </Row>
      <Modal
        isOpen={new_theme_data_modal_status}
        toggle={new_theme_data_modal_action}
      >
        <ModalHeader toggle={new_theme_data_modal_action} tag="h4">
          Veri Ekle - {process_proforma.title}
        </ModalHeader>

        <ModalBody>
          <AvForm onValidSubmit={handle_proforma_data_form}>
            <AvField
              type="hidden"
              name="proforma_id"
              value={process_proforma.id}
            />
            <AvField type="hidden" name="payment_id" value={props.payment_id} />
            <AvField
              type="hidden"
              name="project_id"
              value={process_proforma.project_id}
            />

            <Row form>
              <Col xs={12}>
                {(process_proforma.objects &&
                  process_proforma.objects.length > 0 &&
                  process_proforma.objects.map(prfrm => (
                    <React.Fragment key={prfrm.id}>
                      {prfrm.input_detail == "Radio" && (
                        <div>
                          <Label>{prfrm.input_label}</Label>
                          <AvRadioGroup
                            name={prfrm.input_label}
                            required
                            errorMessage="Lütfen bir seçim yapınız"
                            inline
                          >
                            {(prfrm.addAdditionalRow &&
                              prfrm.addAdditionalRow.length > 0 &&
                              prfrm.addAdditionalRow.map(additionalElement => (
                                <React.Fragment key={additionalElement.id}>
                                  <AvRadio
                                    label={additionalElement.title}
                                    value={additionalElement.deger}
                                  />
                                </React.Fragment>
                              ))) || <></>}
                          </AvRadioGroup>
                        </div>
                      )}
                      {prfrm.input_detail == "Checkbox" && (
                        <div>
                          <Label>{prfrm.input_label}</Label>
                          <AvCheckboxGroup
                            name={prfrm.input_label}
                            required
                            errorMessage="Lütfen bir seçim yapınız"
                            inline
                          >
                            {(prfrm.addAdditionalRow &&
                              prfrm.addAdditionalRow.length > 0 &&
                              prfrm.addAdditionalRow.map(additionalElement => (
                                <React.Fragment key={additionalElement.id}>
                                  <AvCheckbox
                                    label={additionalElement.title}
                                    value={additionalElement.deger}
                                  />
                                </React.Fragment>
                              ))) || <></>}
                          </AvCheckboxGroup>
                        </div>
                      )}
                      {prfrm.input_detail == "Select" && (
                        <AvField
                          type="select"
                          name={prfrm.input_label}
                          required="required"
                          label={prfrm.input_label}
                        >
                          <React.Fragment>
                            <option value="">Lütfen bir seçim yapınız</option>
                          </React.Fragment>
                          {(prfrm.addAdditionalRow &&
                            prfrm.addAdditionalRow.length > 0 &&
                            prfrm.addAdditionalRow.map(additionalElement => (
                              <React.Fragment key={additionalElement.id}>
                                <option value={additionalElement.deger}>
                                  {additionalElement.title}
                                </option>
                              </React.Fragment>
                            ))) || <></>}
                        </AvField>
                      )}
                      {prfrm.input_detail == "Text" && (
                        <AvField
                          name={prfrm.input_label}
                          label={prfrm.input_label}
                          required="required"
                          type={prfrm.input_detail}
                        />
                      )}
                      {prfrm.input_detail == "File" && (
                        <AvField
                          name={`files[${prfrm.input_label}]`}
                          required="required"
                          id={`id_${prfrm.input_label}`}
                          label={prfrm.input_label}
                          type={prfrm.input_detail}
                        />
                      )}
                    </React.Fragment>
                  ))) || <></>}
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="ms-auto">
                  {user_type == "ADM" || user_type == "PM" ? (
                    <div>
                      <AvField
                        type="select"
                        name="user_id"
                        required="required"
                        label="Kullanıcı"
                      >
                        <React.Fragment>
                          <option value="">Lütfen bir seçim yapınız</option>
                        </React.Fragment>
                        {(users &&
                          users.length > 0 &&
                          users.map(user => (
                            <React.Fragment key={user.id}>
                              <option value={user.id}>{user.name}</option>
                            </React.Fragment>
                          ))) || <></>}
                      </AvField>
                      <AvField
                        name="price"
                        label="Fiyat"
                        type="number"
                        errorMessage="Hatalı Fiyat"
                        validate={{
                          required: { value: true },
                        }}
                      />

                      <AvField
                        name="create_datetime"
                        label="İşlem Tarihi"
                        type="date"
                        errorMessage="Hatalı Tarih"
                        format="yyyy-MM-dd"
                        validate={{
                          required: { value: true },
                        }}
                        defaultValue={new Date().toISOString().substr(0, 10)}
                      />
                    </div>
                  ) : (
                    <div>
                      <AvField
                        type="select"
                        name="user_id"
                        required="required"
                        value={AuthUserData.id}
                        label="Kullanıcı"
                        disabled="disabled"
                      >
                        <React.Fragment>
                          <option value="">Lütfen bir seçim yapınız</option>
                        </React.Fragment>
                        {(users &&
                          users.length > 0 &&
                          users.map(user => (
                            <React.Fragment key={user.id}>
                              <option value={user.id}>{user.name}</option>
                            </React.Fragment>
                          ))) || <></>}
                      </AvField>

                      <AvField
                        name="price"
                        label="Fiyat"
                        type="number"
                        errorMessage="Hatalı Fiyat"
                        validate={{
                          required: { value: true },
                        }}
                      />
                      <AvField
                        name="create_datetime"
                        label="İşlem Tarihi"
                        type="date"
                        errorMessage="Hatalı Tarih"
                        format="yyyy-MM-dd"
                        disabled="disabled"
                        validate={{
                          required: { value: true },
                        }}
                        defaultValue={new Date().toISOString().substr(0, 10)}
                      />
                    </div>
                  )}
                </div>
                <Button color="primary" type="submit">
                  Kaydet
                </Button>
              </Col>
            </Row>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default CollapsibleTable
